import React from "react";

const SvgBBiconsGrHodnoceniSubjektu = props => (
  <svg data-name="Global report" viewBox="0 0 200 200" {...props}>
    <path
      data-name="Hodnoceni subjektu"
      d="M100 33.33c-1.88 0-3.76 1.47-5.2 4.39l-20 34.15-38.74 8.49c-6.43.94-7.87 5.39-3.21 9.93l26.41 29.94-4 39.09c-1.09 6.41 2.66 9.14 8.42 6.12L100 149.58l.39.15.32-3.37-10-11.62c-6.29-6.89-3-16.61 6.14-18.34l13.79-2.93 8.11-13.87c2.22-4.12 5.87-6.25 9.56-6.25s7.35 2.14 9.57 6.27h.05l8 13.77.53.1 20.65-23.15c4.64-4.54 3.21-9-3.22-9.93l-38.83-8.57-19.84-34.12c-1.43-2.92-3.33-4.39-5.22-4.39zm30.78 70.43l9.81 17 17.58 3.78c3 .46 3.73 2.59 1.58 4.76l-12.29 14.24 1.82 19.36c.49 3-1.28 4.28-4 2.81L128.51 158l-17 7.68c-2.69 1.47-4.46.21-4-2.81l1.86-19.26-12.32-14.34c-2.15-2.17-1.45-4.3 1.58-4.76l17.4-3.67 10-17.08c1.3-2.76 3.43-2.76 4.75 0z"
    />
  </svg>
);

export default SvgBBiconsGrHodnoceniSubjektu;
